module.exports = __webpack_public_path__ + "img/rem-koolhaas.21c725fe.png";